export default class Excecao extends Error {
  constructor(mensagem, opcoes = {}) {
    super(mensagem);
    this.mensagem = mensagem;
    this.opcoes = opcoes;
    this.name = 'Excecao';
  }
}



// WEBPACK FOOTER //
// ./src/utils/excecao.js